function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';
import PropTypes from 'prop-types';
import md5 from 'md5';
import { ChevronLeftIconSmall as LeftArrow, ChevronRightIconSmall as RightArrow } from '@domain-group/fe-co-icon';
import * as styles from './allhomes-breadcrumbs.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var BackLink = function BackLink(_ref) {
  var url = _ref.url,
    children = _ref.children;
  return ___EmotionJSX("div", {
    css: styles.back
  }, ___EmotionJSX(LeftArrow, {
    size: "custom",
    css: styles.chrevron
  }), ___EmotionJSX("a", {
    css: styles.link(false),
    href: url,
    onClick: function onClick(event) {
      event.preventDefault();
      window.history.back();
    }
  }, children), ___EmotionJSX("span", {
    css: styles.separator
  }));
};
BackLink.propTypes = {
  url: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
var AllhomesBreadcrumbs = function AllhomesBreadcrumbs(props) {
  var _props$items = _toArray(props.items),
    home = _props$items[0],
    otherItems = _props$items.slice(1);
  var renderItem = function renderItem(item, index, showMeta) {
    var isLast = props.goBackText && props.goBackUrl || props.items.length === 2 ? props.items.length === index + 1 : otherItems.length === index + 1;
    var Item = isLast ? 'span' : 'a';
    return ___EmotionJSX("li", {
      css: styles.item,
      itemProp: "itemListElement",
      itemScope: true,
      itemType: "http://schema.org/ListItem",
      key: md5("".concat(item.text).concat(item.link))
    }, ___EmotionJSX("link", {
      itemProp: "item",
      href: item.link
    }), ___EmotionJSX(Item, {
      css: styles.link(isLast),
      href: item.link
    }, ___EmotionJSX("span", {
      itemProp: "name"
    }, item.text)), showMeta && ___EmotionJSX("meta", {
      itemProp: "position",
      content: index + 1
    }), !isLast && ___EmotionJSX(RightArrow, {
      size: "custom",
      css: styles.chrevron
    }));
  };
  return ___EmotionJSX("div", {
    css: styles.divider
  }, ___EmotionJSX("div", {
    className: props.className,
    css: styles.breadcrumbs,
    role: "navigation"
  }, props.goBackText && props.goBackUrl && ___EmotionJSX(BackLink, {
    url: props.goBackUrl
  }, props.goBackText), !props.goBackText && !props.goBackUrl && props.items.length > 2 && renderItem(home, 0, false), ___EmotionJSX("div", {
    css: styles.breadcrumbsList
  }, ___EmotionJSX("ol", {
    css: styles.itemList,
    itemScope: true,
    itemType: "http://schema.org/BreadcrumbList"
  }, (props.goBackText && props.goBackUrl || props.items.length === 2) && props.items.map(function (item, index) {
    return renderItem(item, index, true);
  }), !props.goBackText && !props.goBackUrl && props.items.length > 2 && otherItems.map(function (item, index) {
    return renderItem(item, index, true);
  })))));
};
AllhomesBreadcrumbs.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    link: PropTypes.string
  })).isRequired,
  className: PropTypes.string,
  goBackUrl: PropTypes.string,
  goBackText: PropTypes.string
};
AllhomesBreadcrumbs.defaultProps = {
  className: '',
  goBackText: '',
  goBackUrl: ''
};
export default AllhomesBreadcrumbs;